import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  FacebookPage,
  GetFacebookPages,
  RemoveBotConnection,
  ResetFacebookAuthStatus,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';

@Component({
  selector: 'brn-facebook-connection-modal',
  templateUrl: './facebook-connection-modal.component.html',
  styleUrls: ['./facebook-connection-modal.component.scss'],
})
export class FacebookConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  @ViewSelectSnapshot(ConnectionsSelectors.facebookAuthStatus)
  facebookAuthStatus!: 'not_connected' | 'pending' | 'connected';

  @ViewSelectSnapshot(ConnectionsSelectors.facebookPages)
  facebookPages!: FacebookPage[];

  newConnection = true;
  valueChanged = false;

  facebookForm = this.formBuilder.group({
    page: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<FacebookConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      this.newConnection = false;
      this.facebookForm.patchValue({
        page: {
          access_token: data.providerData.access_token,
          name: data.providerData.page_name,
        },
      });
    }
  }

  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe(() => {
      this.store.dispatch(new ResetFacebookAuthStatus());
    });
    this.facebookForm.valueChanges.subscribe((v) => {
      this.valueChanged = true;
    });
  }

  getFacebookPages(): void {
    if (
      this.facebookAuthStatus === 'not_connected' ||
      !this.facebookAuthStatus
    ) {
      this.store.dispatch(new GetFacebookPages());
    }
  }

  get pageName(): string {
    return this.facebookForm.value.page.name;
  }

  get validForm(): boolean {
    return this.facebookForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const page = this.facebookForm.value.page;

    const providerData = {
      user_token: page.access_token,
      page_id: page.id,
      get_started: {
        status: false,
      },
    };

    this.store.dispatch(new CreateBotConnection('messenger', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const page = this.facebookForm.value.page;

    const providerData = {
      user_token: page.access_token,
      page_id: page.id,
      get_started: {
        status: false,
      },
    };

    this.store.dispatch(new UpdateBotConnection('messenger', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('messenger'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
